import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { DrillEventsHandler } from '@nrwl/smart-search-base';
import { appRoutes } from './app.routing';
import { HomeComponent } from './fusion-ui/home/home.component';
import {
  APP_ROOT_PARAMS,
  MainEntitiesProvider,
  RootParametersProvider,
  TimeRangeProvider,
  ToastComponent,
  UrlBasedRootParamsProvider,
  UrlBasedTimeRangeProvider,
  ValuesExchangeProvider,
  ValuesExchangeProviderImpl
} from '@nrwl/common-lib';
import { NavigationProvider } from '@nrwl/navigation-abstract';
import { ToastrModule } from 'ngx-toastr';

import { SUPPORTED_LANG } from './fusion-ui/services/locale/variables';
import { FusionUINavigationProvider } from './navigation/navigation.provider.fusion-ui';
import { ROOT_PARAMS } from './navigation/app.root.params';
import { MainEntityService } from './fusion-ui/services/entity/main.entity.service';
import { FusionUiModule } from './fusion-ui/fusion-ui.module';

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FusionUiModule,
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      useHash: true,
      relativeLinkResolution: 'legacy'
    }),
    ToastrModule.forRoot({
      toastComponent: ToastComponent,
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
      closeButton: true
    })
  ],
  providers: [
    { provide: SUPPORTED_LANG, useValue: ['en', 'ro'] },
    { provide: APP_ROOT_PARAMS, useValue: ROOT_PARAMS },
    { provide: NavigationProvider, useClass: FusionUINavigationProvider },
    { provide: ValuesExchangeProvider, useClass: ValuesExchangeProviderImpl },
    { provide: TimeRangeProvider, useClass: UrlBasedTimeRangeProvider },
    { provide: RootParametersProvider, useClass: UrlBasedRootParamsProvider },
    { provide: MainEntitiesProvider, useExisting: MainEntityService },
    Title
  ],
  bootstrap: [HomeComponent]
})
export class AppModule {
  // injecting those services that must be present early on/in order to listen to URL params
  constructor(
    router: Router,
    valuesExchange: ValuesExchangeProvider,
    rootParams: RootParametersProvider,
    timeRange: TimeRangeProvider,
    entitiesService: MainEntityService,
    drillEvents: DrillEventsHandler
  ) {
    // do not redirect to landing page anymore. This is killing params from URL
  }
}
